import { call, put } from 'redux-saga/effects';

import api from 'api';

import { getDeepLinkError, getDeepLinkSuccess } from 'store/deepLink/actions';

import { YG_CABINET_DEEPLINK_ERROR, YG_CABINET_DEEPLINK_SUCCESS } from 'constants/dataDog';

import { trackDatadogRumAction } from 'services/DataDog';

export function* getDeepLink() {
    try {
        const deepLink: { url: string } = yield call(api.user.deepLinks);

        yield put(getDeepLinkSuccess(deepLink.url));

        trackDatadogRumAction(YG_CABINET_DEEPLINK_SUCCESS);
    } catch (error: any) {
        const code = error?.response?.status || 'NO_CODE';
        const message = error?.message || 'NO_MESSAGE';
        const reason = `${code} | ${message}`;

        trackDatadogRumAction(YG_CABINET_DEEPLINK_ERROR, { reason });

        yield put(getDeepLinkError(error));
    }
}
